import { h, defineComponent } from 'vue';
import { Subscriptions } from '@/ui/pages/subscription/Chargebee/details/Subscriptions';

export default defineComponent({
  name: 'SubscriptionLayout',
  setup() {
    return function render() {
      return h(Subscriptions);
    };
  },
});
